<nav
	class="border rounded-2xl border-gray-200 p-6 bg-white m-2 max-h-screen overflow-y-scroll"
>
	<h2>Settings</h2>

	<app-anchor
		[routerLink]="detailsUrl"
		data-intercom-target="profile-details"
		class="ml-6 mt-8"
		[testHook]="testHooks.MyProfileLink"
	>
		My Profile
	</app-anchor>

	<ng-container
		*ngFor="let navSection of navigation$ | async | keyvalue: orderBy"
	>
		<hr aria-hidden="true" class="subnav-divider" />
		<div class="flex items-center mb-2">
			<app-icon [icon]="navSection.value.icon" class="w-6"></app-icon>
			<h4 class="mb-0">{{ navSection.value.title }}</h4>
		</div>

		<ul class="pl-6 flex flex-col gap-2">
			<li *ngFor="let link of navSection.value.links | keyvalue: orderBy">
				<app-anchor
					[routerLink]="link.value.url"
					[intercomAttr]="link.value.dataIntercomTarget"
					[testHook]="testHooks.NavLink"
				>
					{{ link.value.title }}
				</app-anchor>
			</li>
		</ul>
	</ng-container>
</nav>

<div class="grid min-h-0 p-6 overflow-scroll">
	<router-outlet class="hidden-router"></router-outlet>
</div>
